// Copyright ©️ 2026 eVolve MEP, LLC

import { useState } from 'react';

import { strongIsEqual } from 'helpers/strongEntries';

/**
 * Returns the same object for as long as `value` stays deeply equal to it, so effects and memos that depend on it
 * only re-run when its contents change — not every time a new but identical object is built.
 */
export const useDeepStableValue = <T>(value: T): T => {
  const [stableValue, setStableValue] = useState(value);
  const changed = !strongIsEqual(stableValue, value);
  // Updating state during render is React's pattern for deriving state from props; it re-renders before committing.
  if (changed) setStableValue(value);
  return changed ? value : stableValue;
};
